






























import {
  computed, defineComponent, reactive, ref,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';

import {
  createMaterial,
} from '@/api/index';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

const CommonFormWithQuickMaterialCreator = defineComponent({
  components: {
    CommonModalWithPreset,
  },
  props: {
    edit: { default: false },
    useWithModal: { default: false },
  },
  setup(props, { emit }) {
    const { route, router } = useRouter();
    const confirmModal = ref(null);

    const form = reactive({
      id: -1,
      name: '',
      code: '',
      brand: '',
      unit: 'pcs.',
      warnAmount: 0,
      // lotId
      // transactions
      call: async () => {
        const result = await createMaterial(materialInput.value);
        emit('done');
      },
      state: {
        value: 'READY',
      },
    });

    function clear() {
      form.name = '';
      form.code = '';
      form.unit = '';
      form.brand = '';
      form.warnAmount = 0;
    }

    const computedAllowToSubmit = computed(() => {
      if (form.name !== '' || form.code !== '' || form.brand !== '') return true;
      return false;
    });

    const materialInput = computed(() => ({
      name: form.name,
      code: form.code,
      brand: form.brand,
      unit: form.unit,
      warnAmount: parseInt(form.warnAmount as any, 10),
    }));

    return {
      confirmModal,
      computedAllowToSubmit,

      form,
      clear,
    };
  },
});

export default CommonFormWithQuickMaterialCreator;
